const NAVER_CLIENT_ID = 'RQTjH7_G0skkakiW0kou';
export default NAVER_CLIENT_ID;
